import { ReactComponent as IconVk } from 'assets/images/svg/icon-vk.svg'
import { ReactComponent as IconTg } from 'assets/images/svg/icon-tg.svg'
import { ReactComponent as IconOk } from 'assets/images/svg/icon-ok.svg'
import Logo2 from 'assets/images/logo_er_f.svg'
import styles from './Footer.module.scss'
import {useTranslation} from 'react-i18next'
import { OKShareButton, TelegramShareButton, VKShareButton } from "react-share";
const date = new Date()

export const Footer = () => {
    const { t } = useTranslation()
    const copy = `${date.getFullYear()}. ${t('footer_cop')}`
    const host = window.location.origin
    return (
        <footer className={styles.footer}>
            <div className="container">
                <div className={styles.top}>
                    <div className={styles.logo}>
                        <picture>
                            <img src={Logo2} alt="" width={80} height={20}/>
                        </picture>
                    </div>
                    <div className={styles.copy} dangerouslySetInnerHTML={{__html: copy}} />

                    <div className={styles.social}>
                        <span>
                            {t('social_title')}
                        </span>
                        <VKShareButton url={host}>
                            <IconVk width={32} height={32} />
                        </VKShareButton>
                        <OKShareButton url={host}>
                            <IconOk width={32} height={32} />
                        </OKShareButton>
                        <TelegramShareButton url={host}>
                            <IconTg width={32} height={32} />
                        </TelegramShareButton>
                    </div>
                    <a href="https://er.ru/upages/privacy-policy" target="_blank" rel="noreferrer" className={styles.pol} dangerouslySetInnerHTML={{__html: t('footer_pol')}} />
                </div>
            </div>
        </footer>
    )
}
